import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Router from "vue-router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import * as echarts from 'echarts'
import http from './http/index';

Vue.prototype.axios = http;
Vue.prototype.echarts = echarts;

Vue.use(ElementUI);

Vue.config.productionTip = false;

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
